import * as yup from 'yup';
import { Language } from '../../models/WineWidgetModel';

export const validationSchema = yup.object().shape({
  widgetTitle: yup.lazy((widgetTitle) => {
    const languages = Object.keys(widgetTitle);

    return yup.object().shape({
      ...languages.reduce((lang, value) => {
        lang[value] = yup.object().shape({
          title: yup.string().required(`${value.toUpperCase()} cím megadása kötelező`) as yup.StringSchema<string>,
        });

        return lang;
      }, {} as Record<string, yup.ObjectSchema<Language>>),
    });
  }),

  textColor: yup.string().required('Szöveg szín megadása kötelező'),
  backgroundColor: yup.string().required('Háttér szín megadása kötelező'),
  scrollbarColor: yup.string().required('Scrollbar szín megadása kötelező'),
  renderedWines: yup.number().typeError('Megjelenítendő borok számának megadása kötelező').required('Megjelenített borok számának megadása kötelező').min(1, 'A megjelenített borok számának legalább 1-nek kell lennie'),
  wines: yup.array().min(1, 'Legalább 1 bor hozzáadása kötlező'),
  type: yup.string().oneOf(['CUSTOM', 'FEATURED']).required('Elrendezés megadása kötelező'),
});
